<template>
    <div id="EditEntrie">
        <div v-if="!!entry" class="content">
            <div class="header">
                <span class="start-pos">{{entry.startPos}}</span> &nbsp; <span class="bib">{{entry.bib}}</span>
            </div>
            <div class="name">{{entry.name}}</div>
            
            <div>                
                <c-input v-model="entry.state" :title="$t('text.status')" labelWidth="100px" type="select" :options="state" :doubleDot="true"></c-input>
            </div>
            
            <div>
                <c-input v-model="entry.yellowCard" :title="$t('text.yellowCard')" :labelLeft="false" labelWidth="100%" type="checkbox"></c-input>
            </div>
            <div>
                <c-input v-model="entry.redCard" :title="$t('text.redCard')" :labelLeft="false" labelWidth="100%" type="checkbox"></c-input>
            </div>
            <div>
                <c-input v-model="entry.comment" :title="$t('text.comment')" labelWidth="100%" type="textarea" :forceFocus="entry.state === 6"></c-input>
            </div>
            <div class="button-row">
                <c-button :label="$t('text.abort')" type="link-button" @click="abort"></c-button>
                <c-button :label="$t('text.save')" @click="save"></c-button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';

import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';

import CInput from './CInput';
import CButton from './CButton';

export default {
    name: "EditEntrie",
    data: function(){
        return {
            entry: null,
            state: [{
                label: this.$i18n.t('text.state.finished'),
                value: 2
            },{
                label: this.$i18n.t('text.state.can'),
                value: 4
            },{
                label: this.$i18n.t('text.state.dns'),
                value: 5
            },{
                label: this.$i18n.t('text.state.dsq'),
                value: 6
            }],
        }
    },
    methods:{
        ...mapActions([
            glAct.SAVEENTRYCHANGES,
        ]),
        ...mapMutations([
            glMut.SETEDITENTRYID,
            ]),
        abort(){ 
            this.$emit('abort');
            this.end();            
        },
        save(){ 
            this.SAVEENTRYCHANGES(this.entry);
            this.$emit('save');            
            this.end();
        },
        end(){
            this.SETEDITENTRYID(null);
            if (!this.$route.path.includes('/startlist'))
                this.$router.push('/competition/events/event/startlist');

        }
    },
    computed:{
        ...mapGetters(['EditEntry']),
    },
    watch: {
        EditEntry() {
            this.entry = JSON.parse(JSON.stringify(this.EditEntry));
        }
    },
    components: {
        CInput,
        CButton,
    },
    mounted(){
        this.entry = JSON.parse(JSON.stringify(this.EditEntry));
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .content {
        margin-top:10px;
        height: calc(100% - #{$height_mid});
        overflow-x:auto;
        background-color: $form-bg-color;
        padding:10px; 
        padding-top:5px; 
        font-size: 16px;
        > div {
            padding-bottom: 10px;;
        }

        .header {            
            font-size:30px;
            font-weight: bold;

            .start-pos::before, .bib::before {
                font: normal normal normal 30px "Material Design Icons";
            }

            .start-pos::before {
                content:"\F04BC";
            }

            .bib::before {
                content:"\F0631";
            }
        }

        .name {
            font-size:14px;
        }

        select {
            color: $font-light-color;
            height: $height_default;
            width:100%;
            background-color: $prim_bg_color;
            font-size: 20px;
        }

        .button-row {
            @extend %f-row;
            justify-content: flex-end;
        }
    }

</style>